const primaryColor = "#181D36"
const headerQueryColor = "#BD9D50"
const lightColor = "#454A52"
const borderColor = "#F0F3F7"
const backGroundColor = "#f4f9ff"
const buttonBackground1 = "#7A849C"

export {
    backGroundColor, borderColor, buttonBackground1, headerQueryColor,
    lightColor, primaryColor
}

